import { ReactNode } from 'react';
import Stack from '@mui/material/Stack';

export interface TwoColumnLayoutProps {
  children?: ReactNode;
}

export const TwoColumnLayout = ({ children }: TwoColumnLayoutProps) => {
  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} gap={3}>
      {children}
    </Stack>
  );
};
